export const getMenuId = (publishConfig) => {
    return publishConfig.cartId && publishConfig.cartId !== '-' ? publishConfig.cartId : publishConfig.menuId;
}
